<template>
  <div>
    <div class="custom-control custom-radio">
      <input
        type="radio"
        class="custom-control-input"
        v-model="tempValue"
        :id="name + '-no'"
        :name="name"
        :value="false"
        v-on:change="$emit('input', tempValue)"
      />
      <label class="custom-control-label" :for="name + '-no'">No</label>
    </div>
    <div class="custom-control custom-radio">
      <input
        type="radio"
        class="custom-control-input"
        v-model="tempValue"
        :id="name + '-yes'"
        :name="name"
        :value="true"
        v-on:change="$emit('input', tempValue)"
      />
      <label class="custom-control-label" :for="name + '-yes'">Yes</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "YesNo",
  props: {
    name: String,
    value: Boolean
  },
  data() {
    return {
      tempValue: this.$props.value
    };
  }
};
</script>
